<script setup lang="ts">
import type { UmbracoFormData, DefaultUmbracoFormSubmitData } from 'types/blocks';
import { reset } from '@formkit/core';

const config = useRuntimeConfig();
const apiBase = config.public.apiBase;
const formIsCompleted = ref<boolean>(false);
const props = defineProps<{
  formData: UmbracoFormData;
}>();

async function submitForm(body: DefaultUmbracoFormSubmitData) {
  const formData = new FormData();

  for (const [key, value] of Object.entries(body)) {
    formData.append(key, JSON.stringify(value));
  }

  const res = await $fetch.raw(`${apiBase}/api/forms/${props.formData._id}/entries`, {
    method: 'POST',
    body: formData,
  });

  if (res.ok) {
    formIsCompleted.value = true;
    reset(props.formData._id);
  }
  else {
    const loggingService = useLoggingService();
    loggingService.error('Error submitting form');
  }
}
</script>

<template>
  <FormKit
    v-if="formData.pages.length > 0"
    :id="props.formData._id"
    type="form"
    :submit-label="$t('FormMessages.General.Submit')"
    @submit="submitForm"
  >
    <div
      v-for="(page, pageIndex) in formData.pages"
      :key="`page-${pageIndex}`"
    >
      <div
        v-for="(fieldset, fieldsetIndex) in page.fieldsets"
        :key="`fieldset-${fieldsetIndex}`"
      >
        <div
          v-for="(column, columnIndex) in fieldset.columns"
          :key="`column-${columnIndex}`"
        >
          <div
            v-for="(field, fieldIndex) in column.fields"
            :key="`field-${fieldIndex}`"
          >
            <BaseFormField :field="field" />
          </div>
        </div>
      </div>
    </div>
    <p v-if="formIsCompleted">{{ props.formData.messageOnSubmit }}</p>
  </FormKit>
</template>
